






































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { isConstructing } from "@/models/inventory"
import InfoBox from "./Infobox.vue"
import ConstructingBar from "./ConstructingBar.vue"
import ResourceEntity from "./ResourceEntity.vue"

const MAX_NIGHT_OPACITY = 0.5
const MAX_MORNING_OPACITY = 0.3
const MAX_EVENING_OPACITY = 0.3
const END_NIGHT = 240
const START_DAY = 420
const END_DAY = 1140
const START_NIGHT = 1380

// for yellow effect
const START_MORNING = 240
const END_MORNING = 540
const START_EVENING = 960
const END_EVENING = 1440

const FADEAWAY_TIME = 120

@Component({
    components: {
        InfoBox,
        ResourceEntity,
        ConstructingBar
    }
})
export default class GameBackground extends Vue {
    // Decorators: https://github.com/kaorun343/vue-property-decorator
    // Class: https://github.com/vuejs/vue-class-component
    public nightOpacity: number
    public morningOpacity: number
    public eveningOpacity: number
    @Prop(Boolean) intro: boolean

    constructor() {
        super()
        this.nightOpacity = 0.5
        this.morningOpacity = 0
        this.eveningOpacity = 0
    }

    get solar() {
        return this.$store.getters.hasSource("Solar")
    }

    get coal() {
        return this.$store.getters.hasSource("Coal")
    }
    get petroleum() {
        return this.$store.getters.hasSource("Petroleum")
    }
    get petrolC() {
        this.$store.state.inventory.inventoryChangeNum
        return isConstructing(this.$store.state.inventory.energySources, "Petroleum")
    }
    get biomass() {
        return this.$store.getters.hasSource("Biomass")
    }
    get naturalgas() {
        return this.$store.getters.hasSource("Natural Gas")
    }
    get hydroelectric() {
        return this.$store.getters.hasSource("Hydroelectric")
    }
    get wind() {
        return this.$store.getters.hasSource("Wind")
    }
    get csolarthermal() {
        return this.$store.getters.hasSource("Concentrated Solar Thermal")
    }
    get geothermal() {
        return this.$store.getters.hasSource("Geothermal")
    }
    get coalC() {
        this.$store.state.inventory.inventoryChangeNum
        return isConstructing(this.$store.state.inventory.energySources, "Coal")
    }
    get csolarC() {
        this.$store.state.inventory.inventoryChangeNum
        return isConstructing(this.$store.state.inventory.energySources, 
            "Concentrated Solar Thermal"
        )
    }
    get windC() {
        this.$store.state.inventory.inventoryChangeNum
        return isConstructing(this.$store.state.inventory.energySources, "Wind")
    }
    get hydroC() {
        this.$store.state.inventory.inventoryChangeNum
        return isConstructing(this.$store.state.inventory.energySources, "Hydroelectric")
    }
    get bioC() {
        this.$store.state.inventory.inventoryChangeNum
        return isConstructing(this.$store.state.inventory.energySources, "Biomass")
    }
    get ngasC() {
        this.$store.state.inventory.inventoryChangeNum
        return isConstructing(this.$store.state.inventory.energySources, "Natural Gas")
    }
    get solarC() {
        this.$store.state.inventory.inventoryChangeNum
        return isConstructing(this.$store.state.inventory.energySources, "Solar")
    }
    get nuclearC() {
        this.$store.state.inventory.inventoryChangeNum
        return isConstructing(this.$store.state.inventory.energySources, "Nuclear")
    }
    get geoC() {
        this.$store.state.inventory.inventoryChangeNum
        return isConstructing(this.$store.state.inventory.energySources, "Geothermal")
    }
    get nuclear() {
        return this.$store.getters.hasSource("Nuclear")
    }

    @Watch("$store.state.minsSinceMidnight")
    public dayNightCycle() {
        this.computeNightSvg()
        this.computeMorningSvg()
        this.computeEveningSvg()
    }
    public computeNightSvg() {
        if (
            this.$store.state.minsSinceMidnight > END_NIGHT &&
            this.$store.state.minsSinceMidnight <= START_DAY
        ) {
            this.nightOpacity =
                MAX_NIGHT_OPACITY *
                ((START_DAY - this.$store.state.minsSinceMidnight) /
                    (START_DAY - END_NIGHT))
            // increase darkness
        } else if (
            this.$store.state.minsSinceMidnight > END_DAY &&
            this.$store.state.minsSinceMidnight <= START_NIGHT
        ) {
            this.nightOpacity =
                MAX_NIGHT_OPACITY *
                (1 -
                    (START_NIGHT - this.$store.state.minsSinceMidnight) /
                        (START_NIGHT - END_DAY))
        } else if (
            this.$store.state.minsSinceMidnight < START_NIGHT &&
            this.$store.state.minsSinceMidnight > END_NIGHT
        ) {
            this.nightOpacity = 0
        } else {
            this.nightOpacity = MAX_NIGHT_OPACITY
        }
    }
    public computeMorningSvg() {
        if (
            this.$store.state.minsSinceMidnight > START_MORNING &&
            this.$store.state.minsSinceMidnight < END_MORNING - FADEAWAY_TIME
        ) {
            this.morningOpacity =
                MAX_MORNING_OPACITY *
                (1 -
                    (END_MORNING -
                        FADEAWAY_TIME -
                        this.$store.state.minsSinceMidnight) /
                        (END_MORNING - FADEAWAY_TIME - START_MORNING))
        } else if (
            this.$store.state.minsSinceMidnight > END_MORNING - FADEAWAY_TIME &&
            this.$store.state.minsSinceMidnight < END_MORNING
        ) {
            this.morningOpacity = this.morningOpacity =
                MAX_MORNING_OPACITY *
                ((END_MORNING - this.$store.state.minsSinceMidnight) /
                    (END_MORNING - (END_MORNING - FADEAWAY_TIME)))
        } else if (
            this.$store.state.minsSinceMidnight < START_MORNING &&
            this.$store.state.minsSinceMidnight > END_MORNING
        ) {
            this.morningOpacity = 0
        }
    }
    public computeEveningSvg() {
        if (
            this.$store.state.minsSinceMidnight > START_EVENING &&
            this.$store.state.minsSinceMidnight < END_EVENING - FADEAWAY_TIME
        ) {
            this.eveningOpacity =
                MAX_EVENING_OPACITY *
                (1 -
                    (END_EVENING -
                        FADEAWAY_TIME -
                        this.$store.state.minsSinceMidnight) /
                        (END_EVENING - FADEAWAY_TIME - START_EVENING))
        } else if (
            this.$store.state.minsSinceMidnight > END_EVENING - FADEAWAY_TIME &&
            this.$store.state.minsSinceMidnight < END_EVENING
        ) {
            this.eveningOpacity =
                MAX_EVENING_OPACITY *
                ((END_EVENING - this.$store.state.minsSinceMidnight) /
                    (END_EVENING - (END_EVENING - FADEAWAY_TIME)))
        } else if (
            this.$store.state.minsSinceMidnight < START_EVENING &&
            this.$store.state.minsSinceMidnight > END_EVENING
        ) {
            this.morningOpacity = 0
        }
    }
}
